import { call, put, takeEvery } from "redux-saga/effects";
import { axiosInstance } from "../api";
import store from "../store";
import { ERROR, EDIT_CUSTOMER_STATION_FAILT_SUCCESS, LOADER, EDIT_CUSTOMER_STATION_FAILT, SUCCESS, TOKEN_EXPIRED } from "../actions/types";

function editStationFaultApi(action) {
  let config = {
    headers: {
      "content-type": "multipart/form-data",
      authorizationToken: store.getState().tokenReducer.accessToken,
    },
  };
  let url = `editfault?tab=${action.editPayload.tab}&ID=${action.editPayload.ID}&username=${action.editPayload.username}`;
  return axiosInstance.post(url, action.editPayload.formData, config);
}

function* editStationFaultApiHandler(action) {
  try {
    yield put({
      type: LOADER,
      payload: true,
    });
    const response = yield call(() => editStationFaultApi(action));
    yield put({
      type: LOADER,
      payload: false,
    });

    if (response?.data?.statusCode === 200) {
      yield put({
        type: EDIT_CUSTOMER_STATION_FAILT_SUCCESS,
        response: response.data,
      });
      yield put({
        type: SUCCESS,
        payload: response.data.body.message,
      });
    } else {
      // yield put({
      //   type: LOADER,
      //   payload: false,
      // });
      yield put({
        type: ERROR,
        payload: response.data.body.message,
      });
    }
  } catch (err) {
    yield put({
      type: LOADER,
      payload: false,
    });
    if (err.response?.status === 403) {
      yield put({
        type: TOKEN_EXPIRED,
        payload: true,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000)
    }
    else {
      yield put({
        type: ERROR,
        payload: err.message,
      });
    }

  }
}

function* editStationFault() {
  yield takeEvery(EDIT_CUSTOMER_STATION_FAILT, editStationFaultApiHandler);
}

const editStationFaultSaga = {
  editStationFault: editStationFault(),
};

export default editStationFaultSaga;
